import React, { useEffect } from "react";
import UIfx from "uifx";
import { saveEndTime } from "../GameScreen/helpers/gameInsights";
import { useOvertime } from "../GameScreen/context/useOvertimeContext";
import {
  VictoryContainer,
  VictoryTextDiv,
  VictoryTitle,
  LogoStyle,
  VictoryTimeDiv,
  SocialContainer,
  SocialFlex,
  SocialContainerText,
} from "./styled";
import Logo from "../../assets/Logo.png";

import woohoo from "../../../src/assets/hoohoo.mp3";

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { FacebookIcon, LinkedinIcon, TwitterIcon } from "react-share";

const VictoryScreen = ({
  gameTotalTime,
  completionUrl,
  documentId,
  winnerText,
  loserText,
}) => {
  useEffect(() => {
    const woohooSound = new UIfx(woohoo, {
      volume: 0.3, // number between 0.0 ~ 1.0
      throttleMs: 100,
    });
    woohooSound.play();
  });

  const { overtime } = useOvertime();

  const getTime = () => {
    const getTimeNodes = document.getElementById("Timer").childNodes;
    const time = getTimeNodes[1].innerHTML;

    saveEndTime(documentId, time);
    return time;
  };

  const calculateTime = () => {
    const getTimeNodes = document.getElementById("Timer").childNodes;
    const time = getTimeNodes[1].innerHTML;

    let gameTime = gameTotalTime / 600;

    if (time.replace(":", "") < gameTime) {
      return true;
    } else {
      return false;
    }
  };

  const victoryText = () => {
    if (!overtime || calculateTime()) {
      return [winnerText, "img/victory/Confetti.png"];
    } else {
      return [loserText, "img/victory/Confetti.png"];
    }
  };

  return (
    <div>
      <LogoStyle src={Logo} alt="Logo" />
      <VictoryTextDiv>
        <VictoryTitle>{victoryText()[0]}</VictoryTitle>
      </VictoryTextDiv>
      <VictoryContainer image={victoryText()[1]}>
        <VictoryTimeDiv>
          <h1>{getTime()}</h1>
        </VictoryTimeDiv>
        <SocialContainer>
          <SocialContainerText>
            Enthousiast?! Deel dan jullie eindtijd óf een originele foto op
            social media en maak kans op een gratis Huisarrest spel naar keuze.
            Oh, en vergeet ons niet te taggen! Lees{" "}
            <a
              href="https://huisarrest.com/actievoorwaarden/"
              target="_blank"
              rel="noopener noreferrer"
              className="antwoord-link"
            >
              hier
            </a>{" "}
            de actievoorwaarden
          </SocialContainerText>
          <SocialFlex>
            <TwitterShareButton
              className="share-button"
              url={"huisarrest.com"}
              title="Yes, het is ons gelukt! We speelden een Huisarrest escape room spel en wisten het mysterie binnen de tijd op te lossen. Aanrader! https://huisarrest.com"
            >
              <TwitterIcon url={"huisarrest.com"} round={true} size={50} />
            </TwitterShareButton>
            <FacebookShareButton
              className="share-button"
              url={"huisarrest.com"}
              quote="Yes, het is ons gelukt! We speelden een Huisarrest escape room spel en wisten het mysterie binnen de tijd op te lossen. Aanrader!"
            >
              <FacebookIcon round={true} size={50} />
            </FacebookShareButton>
            <LinkedinShareButton
              className="share-button"
              url={"huisarrest.com"}
              title="Yes, het is ons gelukt! We speelden een Huisarrest escape room spel en wisten het mysterie binnen de tijd op te lossen. Aanrader!"
            >
              <LinkedinIcon round={true} size={50} />
            </LinkedinShareButton>
          </SocialFlex>
          <p className="antwoord-text">
            Nieuwsgierig naar alle oplossingen en uitleg?{" "}
            <a
              className="antwoord-link"
              href={completionUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Klik hier
            </a>
          </p>
        </SocialContainer>
      </VictoryContainer>
    </div>
  );
};

export default VictoryScreen;
